module.exports = __webpack_public_path__ + "img/home_img_13.081b05b3.png";